<template>
  <div class="sidebar-category">
    <div class="header mb-3">
      <button
        class="btn-new-activity"
        @click.prevent="$bvModal.show('modal-create-activity')"
      >
        <img src="@/assets/images/icons/icon-matriz-iper/plus.png" alt="" />
        <span class="ml-2">Nueva actividad</span>
      </button>
      <div class="content-input">
        <img src="@/assets/images/icons/icon-matriz-iper/search.png" alt="" />
        <input
          type="search"
          placeholder="Buscar actividad..."
          v-model="search"
          @keyup="handleSearch"
        />
      </div>
    </div>
    <div class="body">
      <div
        v-if="isLoading"
        class="d-flex justify-content-center align-items-center"
      >
        <b-spinner /> <span class="ml-3">Cargando...</span>
      </div>
      <div v-else>
        <div
          v-if="records.length === 0"
          class="d-flex justify-content-center align-items-center"
        >
          <span>No se encontraron resultados</span>
        </div>
        <div v-else>
          <Activity
            v-for="item in records"
            :key="item.id"
            :record="item"
            :risks="risks"
            @editActivity="(record) => $emit('editActivity', record)"
            @calification="(record) => $emit('calification', record)"
            @history="(id) => $emit('history', id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Activity from "./Activity.vue";

export default {
  components: {
    Activity,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    records: {
      type: Array,
      default: () => [],
    },
    risks: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      search: "",
    };
  },
  watch: {
    search() {
      const me = this;
      if (me.search === null || me.search === "") {
        me.$emit("onSearch", "");
      }
    },
  },
  methods: {
    handleSearch() {
      const me = this;
      me.$emit("onSearch", this.search);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-activity {
  height: 600px;
  width: 100%;
}
.sidebar-activity .header {
  background-color: #eceff1;
  padding: 12px 8px 8px 8px;
}
.content-input {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 22px;
  border: 1px solid #b0bec5;
  padding: 8px 12px 8px 12px;
  height: 32px;
  input {
    border: none;
    outline: none;
    width: 100%;
    font-size: 16px;
  }
  input::placeholder {
    color: #9e9e9e;
  }
  input:focus {
    border: none;
    outline: none;
  }

  input:focus::placeholder {
    color: transparent;
  }
}
.sidebar-activity .body {
  height: 550px;
  width: 100%;
  overflow-y: auto;
  padding-top: 10px;
}
.btn-new-activity {
  border: none;
  color: white;
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  border-radius: 8px;
  padding: 5px;
  padding-right: 10px;
  margin-bottom: 10px;
}
</style>
